<template>
  <page-view title="竞价管理">
    <template slot="action">
      <!-- 获取供应商进出竞价大厅日志 -->
      <BidSupplierOnlineMLog :projectId="projectId"></BidSupplierOnlineMLog>
      <a-button class="ml-1 mr-1" type="primary" icon="rollback" @click="$router.go(-1)">
        返回
      </a-button>
    </template>
    <a-card>
      <div v-if="state === '0'" class="text-center" style="margin: 80px 0">
        <!--                <a-statistic-countdown v-show="false"  :value="beginDate" @finish="onFinish" :prefix="prefix"  format="D天-H时-m分-s秒"/>-->
        <!--                <clock :timer="serverDate" :size="150" border="solid 2px gray" bg="white" color="gray"></clock>-->
        <img style="margin: auto; width: 90px" src="../../../img/empty2.png" />
        <div class="size6 mt-2">竞价未开始</div>
        <a class="mt-2 d-block">竞价操作指南</a>
      </div>
      <a-tabs v-else @change="tabsChange" class="tabb">
        <template>
          <a-tab-pane v-for="it in packsList" :key="it.id">
            <div :class="it.extras.compete ? 'tab-a tab-color' : 'tab-a'" slot="tab">
              {{ it.title }}
            </div>
            <div v-if="it.jingjiaWay === '1'">
              <FreedomCompete :packId="it.id"></FreedomCompete>
            </div>
            <div v-if="it.jingjiaWay === '2'">
              <SingleCompete :packId="it.id"></SingleCompete>
            </div>
          </a-tab-pane>
        </template>
      </a-tabs>
    </a-card>
  </page-view>
</template>

<script>
import FreedomCompete from "./FreedomCompete";
import SingleCompete from "./SingleCompete";
import Clock from "vue-clock2";
import CountDown from "@/components/CountDown/CountDown";
import { PageView } from "@/layouts";
import BidSupplierOnlineMLog from "./BidSupplierOnlineMLog.vue";

export default {
  name: "CompeteHome",
  components: {
    FreedomCompete,
    SingleCompete,
    PageView,
    Clock,
    CountDown,
    BidSupplierOnlineMLog,
  },
  created() {
    this.getBeginState();
  },
  destroyed() {
    // clearInterval(this.dateTimer);
    clearInterval(this.beginTimer);
  },
  data() {
    return {
      deadline: Date.now() + 1000 * 60 * 60 * 24 * 2 + 1000 * 30,
      packsList: [],
      packId: "",
      dateTimer: "",
      showData: true,
      timer: new Date(),
      serverDate: "",
      beginDate: "",
      beginTimer: "",
      state: "1",
      prefix: "距离开标",
      disparity: "",
      changeDisparityTimer: "",
      projectId: this.$route.query.projectId,
      drawerVisible: false,
      status: 0,
    };
  },
  methods: {
    async initPacks() {
      let that = this;
      let res = await this.$http.get(
        "/api/v1/agency/singleCompete/getSignedPacks.json?projectId=" + this.projectId
      );
      that.packsList = res.result.PackList;
      that.packId = res.result.PackList[0].id;
      if (res.result.message) {
        that.$notification["info"]({
          message: "温馨提示",
          description: res.result.message,
          duration: 3,
        });
      }
      if (res.result.allCompete) {
        clearInterval(that.beginTimer);
      }
      for (let i = 0; i < that.packsList.length; i++) {
        var code = that.packsList[i].packCode;
        var newNo = code.substring(code.length - 1, code.length);
        that.packsList[i].title = "包组" + newNo;
      }
      clearInterval(that.changeDisparityTimer);
    },

    changeDisparity() {
      this.disparity = this.disparity - 1000;
      if (this.disparity < 0) {
        this.state = "1";
        this.initPacks();
      }
    },
    getBeginState() {
      let that = this;
      this.$http
        .get("/api/v1/compete/getBeginDate.json?projectId=" + this.projectId)
        .then(function (res) {
          that.beginDate = res.beginDate;
          that.serverDate = res.serverDate;
          that.disparity = res.disparity;
          if (that.disparity > 0) {
            //未开标
            that.state = "0";
            that.changeDisparityTimer = setInterval(that.changeDisparity, 1000);
          } else {
            //已开标
            that.state = "1";
            that.initPacks();
          }
        });
      that.beginTimer = setInterval(that.initPacks, 60000);
    },
    onFinish() {
      this.state = "1";
      this.initPacks();
    },
    tabsChange(key) {
      this.packId = key;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .tab-a {
  margin-top: 10px;
}
/deep/ .tab-color {
  color: #6aee5b;
}

.bubble {
  position: absolute;
  display: inline-block;
  border: 1px solid #ff0000;
  color: #ff0000;
  background-color: #fff;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 22px;
  top: 0;
  transform: scale(0.8);
  right: -20px;
  width: 36px;
  box-sizing: content-box;
  text-align: center;
}
.bubble::before {
  content: "";
  position: absolute;
  bottom: -12px;
  left: 6px;
  display: block;
  height: 0;
  width: 0;
  font-size: 0;
  line-height: 0;
  border-color: #ff0000 transparent transparent transparent;
  border-style: dashed dashed solid dashed;
  border-width: 6px;
}
.bubble::after {
  content: "";
  position: absolute;
  bottom: -11px;
  left: 6px;
  display: block;
  height: 0;
  width: 0;
  font-size: 0;
  line-height: 0;
  border-color: #fff transparent transparent transparent;
  border-style: dashed dashed solid dashed;
  border-width: 6px;
}
.bubble.grey {
  border: 1px solid #8c8c8c;
  color: #8c8c8c;
}
.bubble.grey::before {
  border-color: #8c8c8c transparent transparent transparent;
}
.bubble.green {
  border: 1px solid #109f00;
  color: #109f00;
}
.bubble.red {
  border: 1px solid red;
  color: red;
}
.bubble.green::before {
  border-color: #109f00 transparent transparent transparent;
}
.messageBtn {
  position: absolute;
  top: 75%;
  right: 0%;
}
/deep/ .ant-drawer-body {
  padding: 10px;
}
</style>
